import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/language/[locale]/signin/page.js");
